// Angular
import {
  Component,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
// PrimeNG
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
// Models
import { CostCenter } from '../cost-center-sidebar/models/cost-center.interface';
import { PurchaseOrderForm } from './models/purchase-order-form.interface';
// Components
import { FileUploadInputComponent } from '@shared/components-v3/atomic/file-upload-input/file-upload-input.component';
import { CostCenterSidebarComponent } from '../cost-center-sidebar/cost-center-sidebar.component';
import { FormSubmitDirective } from '@shared/directives-v3/validation-message/directives/form-submit/form-submit.directive';
import { ControlErrorsDirective } from '@shared/directives-v3/validation-message/directives/control-errors/control-errors.directive';
import { SessionService } from '@core/services-v2/session/session.service';
import { ISession } from '@core/models-v2/auth/session.interface';
//libs
import { v1 as uuidv1 } from 'uuid';

const NG_MODULES = [ReactiveFormsModule, CommonModule];
const PRIME_MODULES = [InputTextModule, ButtonModule];
const COMPONENTS = [FileUploadInputComponent, CostCenterSidebarComponent];
const DIRECTIVES = [FormSubmitDirective, ControlErrorsDirective];

@Component({
  selector: 'app-purchase-order-form',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES, COMPONENTS, DIRECTIVES],
  templateUrl: './purchase-order-form.component.html',
  styleUrl: './purchase-order-form.component.scss',
})
export class PurchaseOrderFormComponent implements OnInit {
  @ViewChild('sidebar') sidebar!: CostCenterSidebarComponent;
  @ViewChild('purchaseOrderFormElement')
  purchaseOrderFormElement!: ElementRef;
  purchaseOrderForm!: FormGroup;
  uploadedFiles: any[] = [];
  selectedCostCenter = signal<CostCenter | null>(null);
  session: ISession | null = null;

  private readonly sessionService = inject(SessionService);
  private readonly fb = inject(NonNullableFormBuilder);

  get fileField() {
    return this.purchaseOrderForm.get('file');
  }

  ngOnInit(): void {
    this.session = this.sessionService.getSession();
    this.buildForm();
  }

  private buildForm(): void {
    this.purchaseOrderForm = this.fb.group({
      code: ['', Validators.required],
      file: [null as File[] | null],
      costCenterCode: '',
    });
  }

  /**
   * Al seleccionar centro de costo desde el sidebar.
   * @param selectedCostCenter - Centro de costo seleccionado.
   */
  onSelectCostCenter(selectedCostCenter: CostCenter): void {
    this.selectedCostCenter.set(selectedCostCenter);
  }

  /**
   * Dispara el evento submit del formulario y valida sus estado.
   * - Este método es llamado desde el componente padre.
   */
  submit(): PurchaseOrderForm | null {
    this.purchaseOrderFormElement.nativeElement.dispatchEvent(
      new Event('submit', { cancelable: true })
    );
    return this.purchaseOrderForm.valid
      ? (this.purchaseOrderForm.value as PurchaseOrderForm)
      : null;
  }

  /**
   * Dispara el evento submit del formulario.
   */
  nativeSubmit(): void {
    if (!this.purchaseOrderForm.valid)
      this.purchaseOrderForm.markAllAsTouched();
  }
}
